// @flow
import { PWR_DISTRO_CLIENT_IDS } from './pwrDistroClientIds';

/**
 * Determines if client should use pwr-distro endpoints
 * Falls back to hardcoded list if distribution API fails
 */
export const getUsePwrDistroEndpoints = (clientProps: ?Object): boolean => {
  if (clientProps && clientProps.distributionStatus !== undefined) {
    const { distributionStatus } = clientProps;

    if (typeof distributionStatus === 'boolean') {
      return distributionStatus;
    }

    if (distributionStatus instanceof Error) {
      return clientProps.clientId
        ? PWR_DISTRO_CLIENT_IDS.includes(clientProps.clientId)
        : false;
    }
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/config/pwrDistroConfig.js